import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { HeadingH1 } from '@hausgold/designsystem';
import PropTypes from 'prop-types';
import 'react';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var WizardHeading = function WizardHeading(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(HeadingH1, _extends({
    as: "div",
    textAlign: "center",
    mb: 8
  }, props), children);
};
WizardHeading.propTypes = {
  children: PropTypes.node
};
WizardHeading.defaultProps = {
  children: null
};
export { WizardHeading as default };